import AsyncLoader from 'commons/components/AsyncLoader';

export const ChartGraph = AsyncLoader(() => import('./ChartGraph'));
